/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What a sign-in revocation revoked.
 */
export type RevokeSignInsResult = {
  /**
   * Number of MCP grants revoked.
   */
  revokedSessions: number;
  /**
   * Number of sign-ins revoked.
   */
  revokedSignIns: number;
};

/** @internal */
export const RevokeSignInsResult$inboundSchema: z.ZodMiniType<
  RevokeSignInsResult,
  unknown
> = z.pipe(
  z.object({
    revoked_sessions: z.int(),
    revoked_sign_ins: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "revoked_sessions": "revokedSessions",
      "revoked_sign_ins": "revokedSignIns",
    });
  }),
);

export function revokeSignInsResultFromJSON(
  jsonString: string,
): SafeParseResult<RevokeSignInsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RevokeSignInsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RevokeSignInsResult' from JSON`,
  );
}
